import { MessageObserverInterface } from "./observer/messageObserverInterface";

interface concreteInterface {
  attach(item: MessageObserverInterface): void;
  detach(): void;
  notify(): void;
}

export class MessageConcreteObserver implements concreteInterface {
  protected observers: MessageObserverInterface[] = [];

  public attach(item: MessageObserverInterface) {
    this.observers.push(item);
  }

  public detach(): void {
    this.observers = [];
  }

  notify(): void {
    this.observers.map((item) => {
      item.handle();
    });
  }

  public handleSendConcrete = () => {
    this.notify();
  };
}
